/**
 * PIN lock utilities — SHA-256 hashing via Web Crypto API.
 * The PIN is salted with the user's ID so the same PIN
 * produces different hashes for different users.
 */

const SALT_PREFIX = 'bearsecurity_pin_v1_';

/**
 * Hash a 4-6 digit PIN using SHA-256 with a user-specific salt.
 * Returns a hex string.
 */
export async function hashPin(pin, userId) {
  const data = new TextEncoder().encode(`${SALT_PREFIX}${userId}:${pin}`);
  const buffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Verify a PIN candidate against a stored hash.
 */
export async function verifyPin(candidate, storedHash, userId) {
  const candidateHash = await hashPin(candidate, userId);
  return candidateHash === storedHash;
}
